<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item
        label="类型名称"
        prop="name"
      >
        <a-input
          v-model="form.name"
          placeholder="请输入类型名称"
          :maxLength="30"
        />
      </a-form-model-item>
      <a-form-model-item
        label="试片面积（cm²）"
        prop="pieceArea"
      >
        <a-input-number
          v-model="form.pieceArea"
          :min="0"
          :precision="3"
          style="width: 100%;"
          :maxLength="30"
          placeholder="请输入试片面积（cm²）"
        />
      </a-form-model-item>
      <a-form-model-item
        label="交流试片面积（cm²）"
        prop="acPieceArea"
      >
        <a-input-number
          v-model="form.acPieceArea"
          :min="0"
          :precision="3"
          style="width: 100%;"
          :maxLength="30"
          placeholder="请输入交流试片面积（cm²）"
        />
      </a-form-model-item>
      <a-form-model-item
        label="备注"
        prop="userName"
      >
        <a-input
          type="textarea"
          v-model="form.remark"
          placeholder="请输入备注"
          :maxLength="50"
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button
            type="primary"
            :loading="submitLoading"
            @click="submitForm"
          >
            保存
          </a-button>
          <a-button
            type="dashed"
            @click="cancel"
          >
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDeviceType, addDeviceType, updateDeviceType } from '@/api/saifuneng/devicetype'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      customList: [],
      // 表单参数
      form: {
        id: null,
        name: null,
        pieceArea: null,
        acPieceArea: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '类型名称不能为空', trigger: 'blur' }
        ],
        pieceArea: [
          { required: true, message: '试片面积不能为空', trigger: 'blur' }
        ],
        acPieceArea: [
          { required: true, message: '交流试片面积不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {

  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        pieceArea: null,
        remark: null,
        acPieceArea: null
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDeviceType({ "id": id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateDeviceType(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addDeviceType(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }

  }
}
</script>
